import { PollingStatus } from '@/tax/models';

const supportedTypes = ['pdf', 'md', 'docx'];
export type DocumentType = (typeof supportedTypes)[0];

export class RagFile {
    id = 0;
    organisation = 0;
    file = '';
    filename?: string;
    fileType?: DocumentType;
    creationDate = new Date();
    lastStatus?: PollingStatus;

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.file = data.file ?? '';
        this.filename = data.filename ?? undefined;
        if (this.filename !== undefined) {
            let lastidx = this.filename.lastIndexOf('/');
            if (lastidx > 0) {
                this.filename = this.filename.slice(lastidx + 1, this.filename!.length);
            }
            lastidx = this.filename.lastIndexOf('.');
            if (lastidx > 0) {
                const ext = this.filename.slice(lastidx + 1);
                this.fileType = supportedTypes.includes(ext) ? (ext as DocumentType) : undefined;
                this.filename = this.filename.slice(0, lastidx);
            }
        }
        this.organisation = data.organisation ?? 0;
        this.lastStatus = data.last_status ?? undefined;
        this.creationDate = data.created_at ? new Date(data.created_at) : new Date();
        return this;
    }
}
